<template>
  <div class="container signup-container">
    <div class="signup-row">
      <div class="copy">
        <p>DOWONLOAD A FREE GUIDE TO OPTIMIZE YOUR DIGITAL DETOX</p>
      </div>
      <div class="signup-form">
        <button @click="detoxLink()" class="signup-button home-top">DOWNLOAD</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { db } from '../firebase';
  import 'firebase'

  export default {
    data() {
      return {
        emails: [],
        newEmail: ''
      }
    },
    firestore() {
      return {
        emails: db.collection('emails'),
      }
    },
    methods: {
      addEmail: function() {
        this.$firestore.emails.add(
          {
            name: this.newEmail,
            timestamp: new Date()
          }
        );
        this.newEmail = '';
      },
      detoxLink() {
        window.open("https://jackie-serviss.mykajabi.com/detoxoptin", "_blank"); 
      }
    },
    mounted: function () {
      // setTimeout(() => this.alertDisplay(), 1500);
    }
  }

  
</script>

<style scoped>

  .contact-container .signup-form { text-align: center !important; }

  .signup-container {
    background-color: #8587c5;
    padding: 20px 0;
    height: auto;
    display: flex;
    justify-content: center;
  }
  .signup-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 80%;
  }

  .signup-row p {
    color: #fff;
    padding: 10px 20px;
    font-size: 26px;
    margin: 0;
    font-family: brandon-grotesque, sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .copy, 
  .signup-form { width: 50%; }

  .signup-input {
    border: none;
    border-radius: 5px 0 0 5px;
    padding: 17px 20px;
    font-size: 20px;
    width: 50%;
  }

  .signup-button.home-top {
    border: none;
    background-color: #2e3192;
    color: #fff;
    font-size: 20px;
    padding: 17px 20px 17px 20px;
    /*border-radius: 0 5px 5px 0;*/
    border-radius: 5px;
    left: -4px;
    top: 0;
    position: relative;
    transition: all 0.15s linear;
  }
  .signup-button:hover {
    background-color: #5c5eb4;
  }

  .signup-button:focus {
    outline: none;
  }

  /*NEW POPUP*/
  .swal2-popup {
    width: 50% !important;
  }


  
  @media (max-width: 1130px) and (min-width: 975px) {
    .signup-row p { font-size: 20px; }
  }

  @media (max-width: 775px) {

    .signup-row {
      display: flex;
      flex-direction: column;
      justify-content: center;
      /*align-items: center;*/
      width: 100%;
    }
    .signup-row p { font-size: 16px; }

    .copy, .signup-form {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .copy {
      margin-top: -10px;
    }

    .signup-input { padding: 6px 20px; }
    .signup-button.home-top { padding: 7px 20px; }

    .signup-row p { text-align: center; }

  }

</style>


// WEBPACK FOOTER //
// src/components/NewsletterSignup.vue